import React, {useState} from 'react';
import UserInfo from './UserInfo';
import DecoderInfo from './DecoderInfo';
import { fetchUser, fetchUserDecoders } from '../../service/subscribers/subscribersApi';
import ModalWindow from "../components/ModalWindow";

const Modal = (props) => {
    const {id, domain, fetchList, regions, currenciesL} = props;
    const [modal, setModal] = useState(false);
    const [user, setUser] = useState({});
    const [decList, setDecList] = useState([]);
    const [deletable, setDeletable] = useState([]);
    
    const fetchUserData = async () => {
      try{
        const data = await fetchUser(id);
        setUser(data || {});
      }catch(e){
        console.error(e.message)
      }
    }
    
    const fetchDecoders = async () => {
        try{
            const { decoders, deletable: deletableFlags } = await fetchUserDecoders(id);
            setDecList(decoders);
            setDeletable(deletableFlags);
        }
        catch(error){
            console.error(error);
        }
    }

    const open = () => {
      setModal(true);
      document.body.style.overflow = 'hidden';
      setDecList([]); // Reset decoders list to ensure fresh data
      setUser({}); // Reset user to ensure fresh data
      fetchUserData();
      fetchDecoders();
    }

    const close = () => {
      setModal(false);
      document.body.style.overflow = 'auto';
      fetchList();
    }

    return(
      <div>
        <button className='requestBtn' onClick={open}>Edit</button>
        {modal && <ModalWindow>
            <div className='user-modal-box'>
            <button className='closeBtn' onClick={close}>Close</button>

                <div className='user-modal-content'>
                  <UserInfo
                    regions={regions}
                    user={user}
                    id={id}
                    domain={domain}
                    onDecodersChanged={fetchDecoders}
                  />
                  <DecoderInfo currenciesL={currenciesL} region={user?.region} domain={domain} decoders={decList} id={id} fetchAgain={fetchDecoders}/>
                </div>
            </div>
        </ModalWindow>} 
      </div>
    )
}


export default Modal